"use client";

// Blok "Gratis hadiah" di halaman produk yang tercakup aturan hadiah (mig 8680;
// bertarget produk / kategori / merek / semua produk mig 8780 — rencana §6.2, §14.7). Data dari indeks hadiah server (`GiftIndexContext`, mig 8740
// rencana §13.3) — tanpa query browser; indeks kosong/gagal = blok tak tampil.
// Hak sesungguhnya (termasuk jatah kuota per pembeli) dihitung keranjang &
// server saat checkout.

import { Gift } from "lucide-react";
import { useMemo } from "react";

import { StoreImage } from "@/components/StoreImage";
import { useGiftIndex } from "@/context/GiftIndexContext";
import { bundleCustomerSlot } from "@/lib/bundle";
import { giftRemainingLabel, type GiftProductRef } from "@/lib/gift";
import { productGiftOffers } from "@/lib/giftCart";
import type { CustomerGroup } from "@/lib/reseller-groups";

export function ProductGiftBlock({ product, group }: { product: GiftProductRef; group: CustomerGroup }) {
  const { data, now } = useGiftIndex();
  const slot = bundleCustomerSlot(group);
  const { id, brand, category, productType } = product;
  const offers = useMemo(
    () => productGiftOffers(data, { id, brand, category, productType }, slot, now),
    [data, id, brand, category, productType, slot, now]
  );

  if (!offers.length) return null;
  return (
    <div className="space-y-2">
      <h2 className="flex items-center gap-1 text-sm font-extrabold text-ink">
        <Gift size={15} className="text-shopee" /> Gratis hadiah
      </h2>
      {offers.map(({ rule, reward, sentence, remaining }) => (
        <div key={rule.id} className="flex items-center gap-3 rounded-xl border border-shopee/30 bg-shopeeSoft/30 p-3">
          <div className="relative h-12 w-12 shrink-0 overflow-hidden rounded-lg bg-neutral-100">
            {reward.imageUrl ? (
              <StoreImage src={reward.imageUrl} alt={reward.name} fill sizes="48px" className="object-cover" />
            ) : (
              <div className="grid h-full w-full place-items-center text-muted">
                <Gift size={18} />
              </div>
            )}
          </div>
          <div className="min-w-0">
            <p className="text-xs font-extrabold text-ink">{sentence}</p>
            <p className="mt-0.5 text-[11px] font-semibold text-muted">
              Hadiahnya muncul di keranjang begitu syaratnya terpenuhi.
            </p>
            {giftRemainingLabel(remaining) ? (
              <p className="mt-0.5 text-[11px] font-extrabold text-shopee">{giftRemainingLabel(remaining)}</p>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
